<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!invoice" key="no-invoice"/>
            <div v-else class="col-xl-8" key="invoice">
                <div class="row d-print-none">
                    <div class="
                    col-12
                    pr-0
                    mb-4
                    d-sm-flex
                    justify-content-sm-between
                    align-items-sm-start">
                        <div>
                            <h4>Invoice {{ invoice.number }}</h4>
                            <p class="mb-0 text-muted">
                                <small>Created on {{ invoice.created_at | date }}</small><br>
                                <small v-if="invoice.sent_to">
                                    Sent on {{ invoice.sent_at | date }}<br>
                                    to: {{ invoice.sent_to }}
                                </small>
                            </p>
                            <p class="mb-0 text-muted">
                                <small v-if="invoice.order">
                                    Invoice generated based on
                                    <router-link :to="{
                                    name: 'order',
                                    params: {
                                    orderType: invoice.order.type_code,
                                    id: invoice.order.id,
                                    }}">
                                        {{ invoice.order.number }}
                                    </router-link>
                                </small>
                            </p>
                        </div>
                        <div class="d-sm-flex col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                            <button class="btn btn-primary"
                                    @click="openSendInvoiceModal">
                                Send invoice
                            </button>
                            <b-dropdown variant="link"
                                        no-caret
                                        right>
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item @click="print">
                                    Print
                                </b-dropdown-item>
                                <b-dropdown-item @click="getInvoicePdf">
                                    Export to PDF
                                </b-dropdown-item>
                                <b-dropdown-item @click="destroy" :disabled="!canDelete">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>

                <div class="alert alert-info" v-if="generatingPdf">
                    <strong>Generating PDF</strong>
                    <br><span>Loading...</span>
                </div>

                <InvoiceData/>
                <InvoiceNoModal/>
                <InvoiceDatesModal/>
                <InvoiceLineModal/>
                <InvoiceNotesModal/>
                <InvoiceSendModal/>
                <InvoiceFooterNoteModal/>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import download from 'downloadjs';
import NotificationService from '../../services/notification.service';
import AppPlaceholder from '../form/AppPlaceholder';
import InvoiceLineModal from './InvoiceLineModal';
import InvoiceNotesModal from './InvoiceNotesModal';
import InvoiceNoModal from './InvoiceNoModal';
import InvoiceDatesModal from './InvoiceDatesModal';
import InvoiceData from './InvoiceData';
import { formatDate } from '../../filters/date.filter';
import InvoiceSendModal from './InvoiceSendModal';
import InvoiceFooterNoteModal from './InvoiceFooterNotemodal';

export default {
  components: {
    AppPlaceholder,
    InvoiceLineModal,
    InvoiceData,
    InvoiceNoModal,
    InvoiceNotesModal,
    InvoiceDatesModal,
    BDropdown,
    BDropdownItem,
    InvoiceSendModal,
    InvoiceFooterNoteModal,
  },
  filters: {
    date: formatDate,
  },
  data() {
    return {
      generatingPdf: false,
    };
  },
  computed: {
    ...mapGetters({
      invoice: 'invoices/invoice',
      totalAmount: 'invoices/totalAmount',
    }),
    canDelete() {
      return !this.invoice.sent_to;
    },
  },
  mounted() {
    this.initInvoice();
  },
  watch: {
    '$route.params.id'() {
      this.initInvoice();
    },
  },
  methods: {
    openSendInvoiceModal() {
      this.$store.commit('invoices/isSendInvoiceModalOpen', true);
    },
    print() {
      window.print();
    },
    getInvoicePdf() {
      this.generatingPdf = true;

      this.$store.dispatch('invoices/getInvoicePdf', this.$route.params.id)
        .then((res) => {
          NotificationService.success('Invoice PDF generated. Downloading...');
          download(res.file, res.name, 'application/pdf');
        })
        .finally(() => {
          this.generatingPdf = false;
        });
    },
    initInvoice() {
      this.$store.dispatch('invoices/getInvoice', this.$route.params.id);
    },
    destroy() {
      this.$bvModal.msgBoxConfirm('Delete invoice?', {
        okTitle: 'Delete',
        okVariant: 'danger',
      })
        .then((value) => {
          if (value) {
            this.$store.dispatch('invoices/deleteInvoice')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'invoices' });
              });
          }
        });
    },
  },
};
</script>
